export enum BUCKETS_VALIDATION_ERRORS_API_MESSAGES {
  ADD = 'already exists for',
  MODIFY = 'Existing bucket'
}

export enum BUCKETS_ERRORS_MESSAGES {
  BUCKET_NAME_VALIDATION = 'This collection name already exists. Please select a different name.'
}
